import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75b1abab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pushRequestContainer" }

import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { AppName } from '@/data/Branding';
import { usePushNotificationStore } from '@/stores/PushNotification';

interface Props {
  showClose?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PushNotificationPermissionBanner',
  props: {
    showClose: { type: Boolean, default: true }
  },
  setup(__props: any) {

const pushNotificationStore = usePushNotificationStore();



const message: ComputedRef<string> = computed(() => {
  return `${AppName} needs your permission to enable notifications on this device`;
});

function requestPushNotificationPermission(): void {
  pushNotificationStore.requestPushNotificationPermission();
}

function dismissBanner(): void {
  // Flag in local storage that the user dismissed the banner so we don't annoy them each time they reload
  pushNotificationStore.setBannerDismissed(true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "prompt",
      onClick: requestPushNotificationPermission,
      title: "Enable notifications"
    }, _toDisplayString(message.value), 1),
    (_ctx.showClose)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "close",
          onClick: dismissBanner,
          title: "Dismiss this banner"
        }, [
          _createVNode(BrandIcon, {
            name: "special/dismiss",
            class: "icon"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})